import api from "@/api/api-v2-config";



export async function deleteSegment(id) {    
    return await api.delete("marketings/deletemarketingsegment?id=" +  id);
}

export async function postSegment(payment) {    
    return await api.post("marketings/createmarketingsegment", payment);
}

export async function updateSegment(payment) {
    return await api.put("marketings/updatemarketingsegment", payment);
}


export async function getSegment(id) {    
    return await api.get("marketings/createmarketingsegment/" + id);
}


export async function getSegments() {    
    return await api.get("marketings/getmarketingsegmentlist?PageNumber=1&PageSize=10000");
}

export async function getCustomersBySegment(id) {
    return await api.get("customers/segment/" + id);
}
